import { api } from "../api";
import { CoOwnerResult, RegisterQTDTO } from "@/types/portal/Registration";
import { withoutActorIdentity } from "./actorIdentity";

export const searchCoOwner = async (membershipID: string): Promise<CoOwnerResult[]> => {
    const { data } = await api.get<CoOwnerResult[]>(`/Person/search/qt/${membershipID}`)
    return data;
}

export const registerQTDog = async(registerDTO: RegisterQTDTO): Promise<any> => {
    const { data } = await api.post<object>(`/Dog/qt/register`, withoutActorIdentity(registerDTO));
    return data;
}

export default {
    searchCoOwner,
    registerQTDog,
}
